<div class="text-box-container">
  <div class="question-header">
    <h6 class="question-title"
    [style.font-size]="questionnaire?.mainContentTemplate?.questionStyle?.fontSize + 'px'"
    [style.font-family]="questionnaire?.mainContentTemplate?.questionStyle?.fontFamily"
    [style.font-weight]="questionnaire?.mainContentTemplate?.questionStyle?.boldStyle"
    [style.color]="questionnaire?.mainContentTemplate?.questionStyle?.fontColor"
    >
      {{ questionNumber }}. {{ question?.question || 'Untitled Question' | titlecase }}
      @if (question?.required) {
      <span 
      [style.font-size]="'18px'"
      [style.font-family]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontFamily"
      [style.font-weight]="questionnaire?.mainContentTemplate?.errorMessageStyle?.boldStyle"
      [style.color]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontColor"
      >*</span>
      }
    </h6>
  </div>

  <div class="question-content-dropdown">
    <div class="dropdown-container">
      <div
        class="dropdown-header"
        [class.is-invalid]="isInvalid"
        [class.disabled]="disabled"
        (click)="toggleDropdown()"
      >
        <div class="selected-tags-container">
          @if(selectedOptions.length > 0) {
            @for(option of selectedOptions; track option.value) {
              <div class="selected-tag">
                <span class="tag-label">{{ option.label | titlecase }}</span>
                <i 
                  class="bi bi-x-circle tag-cancel"
                  (click)="removeOption($event, option)"
                  title="Remove"></i>
              </div>
            }
          } @else {
            <span class="placeholder">Select your options</span>
          }
        </div>
        <i class="bi bi-chevron-down dropdown-icon"></i>
      </div>

      @if(dropdownOpen) {
      <div class="dropdown-list">
        @if(allowSearch) {
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (input)="onSearchChange()"
          class="search-input"
          placeholder="Search..."
        />
        } @if(noResults) {
        <div class="no-results">No results found</div>
        } @for(option of filteredOptions; track option.value) {
        <div
          class="dropdown-option"
          [class.selected]="isSelected(option)"
          (click)="selectOption(option)"
        >
          <i
            class="bi"
            [class.bi-check-square-fill]="isSelected(option)"
            [class.bi-square]="!isSelected(option)"
          >
          </i>
          <span>{{ option.label | titlecase }}</span>
        </div>
        }
      </div>
      }
    </div>
  </div>

  @if (question?.questionOptions) {
    @for (option of question?.questionOptions; track option.optionId) {
      @if (isOthersSelected(option.optionId)) {
        <div class="others-input-container">
          <input
            type="text"
            class="others-input"
            [ngModel]="getOthersText(option.optionId)"
            [disabled]="disabled"
            placeholder="Please specify"
            (ngModelChange)="onOthersTextChange(option.optionId, $event)"
            (blur)="onOthersInputBlur()"
          />
        </div>
      }
    }
  }
</div>
